exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.label-subitem[data-v-4e090c58]{padding-top:10px;color:#707070\n}\n.valido[data-v-4e090c58]{color:#009c66;width:50%\n}\n.invalido[data-v-4e090c58]{color:firebrick;width:50%\n}\n", "", {"version":3,"sources":["/app/frontend/src/components/AppItemDespachoAutomatizadoValido.vue"],"names":[],"mappings":";AAoCA,gCACE,iBACA,aAAyB;CAC1B;AAAA,yBAGC,cACA,SAAU;CACX;AAAA,2BAGC,gBACA,SAAU;CACX","file":"AppItemDespachoAutomatizadoValido.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import \"@/assets/styles/_variables.scss\";\n\n.label-subitem {\n  padding-top: 10px;\n  color: rgb(112, 112, 112);\n}\n\n.valido {\n  color: #009c66;\n  width: 50%;\n}\n\n.invalido {\n  color: firebrick;\n  width: 50%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e090c58","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppItemDespachoAutomatizadoValido.vue
// module id = QZnk
// module chunks = 11